<div class="create-load-shell fade-in">
  <section class="page-hero">
    <div class="hero-main">
      <span class="eyebrow"><fa-icon [icon]="icons.truck"></fa-icon> {{ ui('Load Posting Workspace', 'مساحة نشر الشحنات') }}</span>
      <h1 class="hero-title">{{ 'LOADS.POST.TITLE' | translate }}</h1>
      <div class="hero-meta">
        <p-tag [value]="ui('Manual entry', 'إدخال يدوي')" severity="secondary" [rounded]="true"></p-tag>
      </div>
    </div>

    <div class="hero-actions">
      <button pButton [routerLink]="['/loads']" class="p-button-outlined p-button-secondary action-button icon-button">
        <fa-icon [icon]="icons.arrowLeft"></fa-icon>
        <span>{{ ui('Back to Loads', 'العودة إلى الشحنات') }}</span>
      </button>
      <button pButton [label]="currentActionLabel" class="p-button-success action-button icon-button"
        [disabled]="isSubmitting()" (click)="submitCurrentAction()">
        <fa-icon [icon]="currentActionIcon"></fa-icon>
      </button>
    </div>
  </section>

  <section class="market-panel steps-panel">
    <p-steps [model]="steps()" [(activeIndex)]="activeStep" [readonly]="true"></p-steps>
  </section>

  <div class="grid board-grid">
    <div class="col-12 xl:col-8 panel-column">
      <section class="market-panel form-panel">
        @if (activeStep === 0) {
        <div class="step-shell fadein">
          <header class="panel-header">
            <div>
              <div class="panel-kicker"><fa-icon [icon]="icons.route"></fa-icon> {{ ui('Lane & Schedule', 'المسار والجدولة') }}</div>
              <h2>{{ ui('Route, stops, and timing', 'المسار والتوقفات والتوقيت') }}</h2>
              <p>{{ ui('Capture the lane, pickup window, delivery date, distance, and shipper reference.', 'أدخل المسار ونافذة الاستلام وتاريخ التسليم والمسافة ومرجع الشاحن.') }}</p>
            </div>
          </header>

          <div class="route-workspace">
            <form [formGroup]="laneForm" class="form-workspace p-fluid">
              <section class="form-section">
                <span class="section-label"><fa-icon [icon]="icons.map"></fa-icon> {{ ui('Lane', 'المسار') }}</span>
                <div class="form-grid">
                  <div class="filter-field">
                    <p-inputGroup>
                      <p-inputGroupAddon><fa-icon [icon]="icons.marker"></fa-icon></p-inputGroupAddon>
                      <p-iftaLabel>
                        <input pInputText id="origin" formControlName="origin" />
                        <label for="origin">{{ ui('Origin', 'مصدر الاستلام') }} *</label>
                      </p-iftaLabel>
                    </p-inputGroup>
                    @if (showError(laneForm, 'origin')) {
                    <small class="p-error">{{ ui('Origin is required.', 'مصدر الاستلام مطلوب.') }}</small>
                    }
                  </div>

                  <div class="filter-field">
                    <p-inputGroup>
                      <p-inputGroupAddon><fa-icon [icon]="icons.route"></fa-icon></p-inputGroupAddon>
                      <p-iftaLabel>
                        <input pInputText id="destination" formControlName="destination" />
                        <label for="destination">{{ ui('Destination', 'وجهة التسليم') }} *</label>
                      </p-iftaLabel>
                    </p-inputGroup>
                    @if (showError(laneForm, 'destination')) {
                    <small class="p-error">{{ ui('Destination is required.', 'وجهة التسليم مطلوبة.') }}</small>
                    }
                  </div>

                  <div class="filter-field full-span">
                    <p-inputGroup>
                      <p-inputGroupAddon><fa-icon [icon]="icons.route"></fa-icon></p-inputGroupAddon>
                      <p-iftaLabel>
                        <textarea pTextarea id="via" formControlName="via" rows="2"></textarea>
                        <label for="via">{{ ui('Via / Intermediate Stops', 'عبر / التوقفات الوسيطة') }}</label>
                      </p-iftaLabel>
                    </p-inputGroup>
                    <small class="field-help">{{ ui('Separate stops with commas or new lines.', 'افصل التوقفات بفواصل أو أسطر جديدة.') }}</small>
                  </div>
                </div>
              </section>

              <section class="form-section">
                <span class="section-label"><fa-icon [icon]="icons.calendar"></fa-icon> {{ ui('Schedule', 'الجدول') }}</span>
                <div class="form-grid">
                  <div class="filter-field">
                    <p-inputGroup>
                      <p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
                      <p-iftaLabel>
                        <p-datepicker id="pickupDate" formControlName="pickupDate" [showIcon]="false"
                          appendTo="body"></p-datepicker>
                        <label for="pickupDate">{{ ui('Pickup Date', 'تاريخ الاستلام') }} *</label>
                      </p-iftaLabel>
                    </p-inputGroup>
                    @if (showError(laneForm, 'pickupDate')) {
                    <small class="p-error">{{ ui('Pickup date is required.', 'تاريخ الاستلام مطلوب.') }}</small>
                    }
                  </div>

                  <div class="filter-field">
                    <p-inputGroup>
                      <p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
                      <p-iftaLabel>
                        <p-datepicker id="deliveryDate" formControlName="deliveryDate" [showIcon]="false"
                          appendTo="body"></p-datepicker>
                        <label for="deliveryDate">{{ 'LOADS.POST.DELIVERY_DATE' | translate }}</label>
                      </p-iftaLabel>
                    </p-inputGroup>
                  </div>

                  <div class="filter-field">
                    <p-inputGroup>
                      <p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
                      <p-iftaLabel>
                        <input pInputText id="pickupWindowStart" type="time" formControlName="pickupWindowStart" />
                        <label for="pickupWindowStart">{{ ui('Pickup Window Start', 'بداية نافذة الاستلام') }}</label>
                      </p-iftaLabel>
                    </p-inputGroup>
                  </div>

                  <div class="filter-field">
                    <p-inputGroup>
                      <p-inputGroupAddon><fa-icon [icon]="icons.calendar"></fa-icon></p-inputGroupAddon>
                      <p-iftaLabel>
                        <input pInputText id="pickupWindowEnd" type="time" formControlName="pickupWindowEnd" />
                        <label for="pickupWindowEnd">{{ ui('Pickup Window End', 'نهاية نافذة الاستلام') }}</label>
                      </p-iftaLabel>
                    </p-inputGroup>
                  </div>

                  <div class="filter-field">
                    <p-inputGroup>
                      <p-inputGroupAddon><fa-icon [icon]="icons.route"></fa-icon></p-inputGroupAddon>
                      <p-iftaLabel>
                        <p-inputNumber inputId="totalDistanceInKm" formControlName="totalDistanceInKm"
                          suffix=" km" [min]="0"></p-inputNumber>
                        <label for="totalDistanceInKm">{{ ui('Total Distance', 'المسافة الإجمالية') }}</label>
                      </p-iftaLabel>
                    </p-inputGroup>
                  </div>

                  <div class="filter-field">
                    <p-inputGroup>
                      <p-inputGroupAddon><fa-icon [icon]="icons.reference"></fa-icon></p-inputGroupAddon>
                      <p-iftaLabel>
                        <input pInputText id="referenceNumber" formControlName="referenceNumber" />
                        <label for="referenceNumber">{{ 'LOADS.POST.REFERENCE' | translate }}</label>
                      </p-iftaLabel>
                    </p-inputGroup>
                  </div>
                </div>
              </section>
            </form>

            <div class="map-frame">
              <app-google-map [origin]="pickupLocation()" [destination]="deliveryLocation()"></app-google-map>
            </div>
          </div>
        </div>
        }

        @if (activeStep === 1) {
        <div class="step-shell fadein">
          <header class="panel-header">
            <div>
              <div class="panel-kicker"><fa-icon [icon]="icons.truck"></fa-icon> {{ ui('Equipment', 'المعدات') }}</div>
              <h2>{{ ui('Vehicle and capacity requirements', 'متطلبات المركبة والسعة') }}</h2>
              <p>{{ ui('Select the equipment and capture unit count, dimensions, volume, and temperature needs.', 'حدد المعدة وأدخل العدد والأبعاد والحجم ومتطلبات الحرارة.') }}</p>
            </div>
          </header>

          <form [formGroup]="equipmentForm" class="form-workspace p-fluid">
            <div class="form-grid">
              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.truck"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input pInputText id="equipment" formControlName="equipment" />
                    <label for="equipment">{{ ui('Equipment', 'المعدة') }} *</label>
                  </p-iftaLabel>
                </p-inputGroup>
                @if (showError(equipmentForm, 'equipment')) {
                <small class="p-error">{{ ui('Equipment is required.', 'المعدة مطلوبة.') }}</small>
                }
              </div>

              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.truck"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <p-inputNumber inputId="equipmentCount" formControlName="equipmentCount"
                      [min]="1"></p-inputNumber>
                    <label for="equipmentCount">{{ ui('Equipment Count', 'عدد المعدات') }} *</label>
                  </p-iftaLabel>
                </p-inputGroup>
                @if (showError(equipmentForm, 'equipmentCount')) {
                <small class="p-error">{{ ui('Equipment count must be at least 1.', 'يجب أن يكون عدد المعدات 1 على الأقل.') }}</small>
                }
              </div>

              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.route"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <p-inputNumber inputId="vehicleLength" formControlName="vehicleLength" suffix=" m"
                      [min]="0"></p-inputNumber>
                    <label for="vehicleLength">{{ ui('Vehicle Length', 'طول المركبة') }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>

              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.route"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <p-inputNumber inputId="vehicleWidth" formControlName="vehicleWidth" suffix=" m"
                      [min]="0"></p-inputNumber>
                    <label for="vehicleWidth">{{ ui('Vehicle Width', 'عرض المركبة') }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>

              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.route"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <p-inputNumber inputId="vehicleHeight" formControlName="vehicleHeight" suffix=" m"
                      [min]="0"></p-inputNumber>
                    <label for="vehicleHeight">{{ ui('Vehicle Height', 'ارتفاع المركبة') }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>

              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.box"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <p-inputNumber inputId="vehicleVolume" formControlName="vehicleVolume" suffix=" CBM"
                      [min]="0"></p-inputNumber>
                    <label for="vehicleVolume">{{ ui('Vehicle Volume', 'حجم المركبة') }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>
            </div>

            <div class="choice-grid">
              <label class="choice-card" for="temperatureControlled">
                <p-checkbox formControlName="temperatureControlled" [binary]="true"
                  inputId="temperatureControlled"></p-checkbox>
                <span><fa-icon [icon]="icons.temperature"></fa-icon></span>
                <strong>{{ 'LOADS.POST.TEMP_CONTROL' | translate }}</strong>
              </label>
            </div>
          </form>
        </div>
        }

        @if (activeStep === 2) {
        <div class="step-shell fadein">
          <header class="panel-header">
            <div>
              <div class="panel-kicker"><fa-icon [icon]="icons.box"></fa-icon> {{ ui('Cargo', 'البضاعة') }}</div>
              <h2>{{ ui('Cargo quantity and requirements', 'كمية البضاعة ومتطلباتها') }}</h2>
              <p>{{ ui('Describe the commodity, amount, weight, pallets, insurance requirement, and carrier notes.', 'صف نوع البضاعة والكمية والوزن والمنصات ومتطلبات التأمين وملاحظات الناقل.') }}</p>
            </div>
          </header>

          <form [formGroup]="cargoForm" class="form-workspace p-fluid">
            <div class="form-grid">
              <div class="filter-field full-span">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.box"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input pInputText id="commodity" formControlName="commodity" />
                    <label for="commodity">{{ 'LOADS.POST.COMMODITY' | translate }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>

              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.box"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input pInputText id="quantity" formControlName="quantity" />
                    <label for="quantity">{{ 'COMMON.QUANTITY' | translate }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>

              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.box"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <p-inputNumber inputId="pallets" formControlName="pallets" [min]="0"></p-inputNumber>
                    <label for="pallets">{{ 'COMMON.PALLETS' | translate }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>

              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.box"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <p-inputNumber inputId="weightKg" formControlName="weightKg" suffix=" kg"
                      [min]="0"></p-inputNumber>
                    <label for="weightKg">{{ ui('Weight', 'الوزن') }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>

              <div class="filter-field full-span">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.pen"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <textarea pTextarea id="notes" formControlName="notes" rows="5"></textarea>
                    <label for="notes">{{ 'COMMON.NOTES' | translate }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
                <small class="field-help">{{ ui('Each new line will be sent as a separate note.', 'سيتم إرسال كل سطر جديد كملاحظة مستقلة.') }}</small>
              </div>
            </div>

            <div class="choice-grid">
              <label class="choice-card" for="insuranceRequired">
                <p-checkbox formControlName="insuranceRequired" [binary]="true" inputId="insuranceRequired"></p-checkbox>
                <span><fa-icon [icon]="icons.shield"></fa-icon></span>
                <strong>{{ ui('Insurance Required', 'التأمين مطلوب') }}</strong>
              </label>
            </div>
          </form>
        </div>
        }

        @if (activeStep === 3) {
        <div class="step-shell fadein">
          <header class="panel-header">
            <div>
              <div class="panel-kicker"><fa-icon [icon]="icons.dollar"></fa-icon> {{ ui('Commercial & Contact', 'التسعير والتواصل') }}</div>
              <h2>{{ ui('Rate, payment, and contact', 'السعر والدفع والتواصل') }}</h2>
              <p>{{ ui('Set the all-in target rate and the contact details carriers need for this request.', 'حدد السعر الشامل وبيانات التواصل التي يحتاجها الناقلون لهذا الطلب.') }}</p>
            </div>
          </header>

          <form [formGroup]="commercialForm" class="form-workspace p-fluid">
            <div class="form-grid">
              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.dollar"></fa-icon></p-inputGroupAddon>
                    <p-iftaLabel>
                    <p-inputNumber inputId="targetRate" formControlName="targetRate" mode="currency"
                      [currency]="currencyResolver.effectiveCurrencyCode(commercialForm.get('currencyCode')?.value)" [min]="0"></p-inputNumber>
                    <label for="targetRate">{{ 'LOADS.POST.TARGET_RATE_ALL' | translate }} *</label>
                  </p-iftaLabel>
                </p-inputGroup>
                @if (showError(commercialForm, 'targetRate')) {
                <small class="p-error">{{ ui('Target rate is required.', 'السعر المستهدف مطلوب.') }}</small>
                }
              </div>

              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.dollar"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input pInputText id="currencyCode" formControlName="currencyCode" maxlength="3" />
                    <label for="currencyCode">{{ ui('Currency', 'العملة') }} *</label>
                  </p-iftaLabel>
                </p-inputGroup>
                @if (showError(commercialForm, 'currencyCode')) {
                <small class="p-error">{{ ui('Currency is required.', 'العملة مطلوبة.') }}</small>
                }
              </div>

              <div class="filter-field full-span">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.creditCard"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input pInputText id="paymentTerms" formControlName="paymentTerms" />
                    <label for="paymentTerms">{{ 'LOADS.POST.PAYMENT_TERMS' | translate }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>

              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.reference"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input pInputText id="contactName" formControlName="contactName" />
                    <label for="contactName">{{ ui('Contact Name', 'اسم جهة الاتصال') }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>

              <div class="filter-field">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.reference"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input pInputText id="contactNumber" formControlName="contactNumber" />
                    <label for="contactNumber">{{ ui('Contact Number', 'رقم التواصل') }} *</label>
                  </p-iftaLabel>
                </p-inputGroup>
                @if (showError(commercialForm, 'contactNumber')) {
                <small class="p-error">{{ ui('Contact number is required.', 'رقم التواصل مطلوب.') }}</small>
                }
              </div>

              <div class="filter-field full-span">
                <p-inputGroup>
                  <p-inputGroupAddon><fa-icon [icon]="icons.reference"></fa-icon></p-inputGroupAddon>
                  <p-iftaLabel>
                    <input pInputText id="clientCompanyName" formControlName="clientCompanyName" />
                    <label for="clientCompanyName">{{ ui('Client Company Name', 'اسم شركة العميل') }}</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>
            </div>
          </form>
        </div>
        }

        @if (activeStep === 4) {
        <div class="step-shell fadein review-shell">
          <header class="panel-header">
            <div>
              <div class="panel-kicker"><fa-icon [icon]="icons.checkCircle"></fa-icon> {{ ui('Review', 'مراجعة') }}</div>
              <h2>{{ 'LOADS.POST.READY_PUBLISH' | translate }}</h2>
              <p>{{ 'LOADS.POST.LIVE_PREVIEW' | translate }}</p>
            </div>
          </header>

          <div class="review-content">
            @for (group of reviewGroups; track group.label) {
            <section class="review-card">
              <span class="section-label"><fa-icon [icon]="icons.invoice"></fa-icon>{{ group.label }}</span>
              <div class="details-list">
                @for (item of group.items; track item.label) {
                <div class="detail-row">
                  <span>{{ item.label }}</span>
                  <strong>{{ item.value }}</strong>
                </div>
                }
              </div>
            </section>
            }
          </div>
        </div>
        }
      </section>
    </div>

    <div class="col-12 xl:col-4 panel-column">
      <aside class="side-stack">
        <section class="action-card">
          <span class="panel-kicker"><fa-icon [icon]="icons.bolt"></fa-icon> {{ ui('Posting Progress', 'تقدم النشر') }}</span>
          <h2>{{ activeStep + 1 }} / {{ steps().length }}</h2>
          <p>{{ ui('Complete each section, review the posting, then publish it to verified carriers.', 'أكمل كل قسم وراجع النشر ثم انشره للناقلين الموثقين.') }}</p>
          <div class="side-actions">
            <button pButton [label]="ui('Back', 'رجوع')" class="p-button-outlined p-button-secondary action-button icon-button"
              [disabled]="activeStep === 0 || isSubmitting()" (click)="previousStep()">
              <fa-icon [icon]="icons.arrowLeft"></fa-icon>
            </button>
            <button pButton [label]="currentActionLabel" class="p-button-success action-button icon-button"
              [disabled]="isSubmitting()" (click)="submitCurrentAction()">
              <fa-icon [icon]="currentActionIcon"></fa-icon>
            </button>
          </div>
        </section>

        <section class="market-panel intelligence-panel">
          <header class="panel-header compact-header">
            <div>
              <div class="panel-kicker"><fa-icon [icon]="icons.bolt"></fa-icon> {{ ui('Intelligence', 'الذكاء') }}</div>
              <h2>{{ 'LOADS.POST.MARKET_INTEL' | translate }}</h2>
            </div>
          </header>

          <div class="details-list">
            @for (item of pricingContext(); track item.label) {
            <div class="detail-row">
              <span>{{ item.label }}</span>
              <strong>{{ item.value }}</strong>
            </div>
            }
          </div>

          <button pButton [label]="'LOADS.POST.LANE_HISTORY' | translate"
            class="p-button-text p-button-secondary icon-button lane-button">
            <fa-icon [icon]="icons.external"></fa-icon>
          </button>
        </section>
      </aside>
    </div>
  </div>
</div>
